// extracted by mini-css-extract-plugin
export default {"friendly":"EcoFriendly_friendly__2D1b3","bgImg":"EcoFriendly_bgImg__JF2QC","content":"EcoFriendly_content__oPG-0","content__block":"EcoFriendly_content__block__kyVsV"};